
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "../ui/use-toast";

export const useSearch = () => {
  const [query, setQuery] = useState("");
  const [isThinking, setIsThinking] = useState(false);
  const [searchResult, setSearchResult] = useState<string | null>(null);
  const [chatId, setChatId] = useState<string | null>(null);
  const { toast } = useToast();

  const handleSearch = async (e: React.FormEvent | null, suggestedQuery?: string) => {
    if (e) e.preventDefault();
    const searchQuery = suggestedQuery || query;
    if (!searchQuery.trim()) return;

    setIsThinking(true);
    setSearchResult(null);

    try {
      console.log('Calling AI function with query:', searchQuery);

      const { data, error } = await supabase.functions.invoke('ask-ai', {
        body: { 
          query: searchQuery,
          generateSuggestions: false // Changed to false
        },
      });

      console.log('AI Response:', data, 'Error:', error);

      if (error) {
        throw error;
      }

      if (!data) {
        throw new Error('No data received from AI');
      }

      setSearchResult(data.answer);
      setChatId(data.chat_id);

    } catch (error) {
      console.error('Error calling AI:', error);
      toast({
        title: "Error",
        description: "An error occurred while processing your request. Please try again.",
        variant: "destructive",
      });
      setSearchResult(null);
    } finally {
      setIsThinking(false);
    }
  };

  return {
    query,
    setQuery,
    isThinking,
    searchResult,
    chatId,
    handleSearch,
  };
};
